const { trackGtm4 } = require('util/functions');

module.exports = {
	init() {
		const pictureLink = this.root.querySelector('a');
		const imageText = this.root.querySelector('img')?.getAttribute('alt');

		pictureLink?.addEventListener('click', () => {
			trackGtm4({
				event: 'GA4_event_c_cta',
				widget_name: 'V3-Image',
				widget_title: 'No title: Picture only',
				link_text: imageText ? `Alt text: ${imageText}` : 'No link text',
				link_url: pictureLink.href,
				button_type: '',
			});
		});
	},
};
